module.exports = __webpack_public_path__ + "static/media/designPatent_30-1064853.365bff76.png";